import { render, staticRenderFns } from "./dataSettings.vue?vue&type=template&id=fc7fccac&scoped=true"
import script from "./dataSettings.vue?vue&type=script&lang=js"
export * from "./dataSettings.vue?vue&type=script&lang=js"
import style0 from "./dataSettings.vue?vue&type=style&index=0&id=fc7fccac&prod&lang=scss"
import style1 from "./dataSettings.vue?vue&type=style&index=1&id=fc7fccac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7fccac",
  null
  
)

export default component.exports